// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6387b27","455":"1ed87b9a","946":"70a78147"}[chunkId] + ".chunk.js";
};